import React from 'react';
import AddDeceased from './AddDeceased';

export default function DeceasedConfirmation(props) {
  return <AddDeceased {...props} isEditing />;
}
